/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-12-03 19:43:00
 */
import * as Vue from 'vue-tsx-support';
import { Component } from 'vue-property-decorator';
import './unitConfig.less';
import FrameSideBg from 'src/pages/layout/components/frameSideBg';
import { createBEM, createNamespace } from 'src/util/bem';
import Tab from 'src/components/tab/tab';
import { Integer } from 'src/types/base';
import UnitConfigService from './service/unitGroupService';
import Strategy from './service/strategy';
import MeasureTypeService from './service/measureTypeService';
import Button from 'src/types/iview/Button';
import SysSideList from '../roleConfig/components/sysSideList';
import FrameContentBg from 'src/pages/layout/components/frameContentBg';
let bem = createBEM('unit-config');

@Component({ name: 'unit-config' })
export default class UnitConfig extends Vue.Component<any> {
    tabs: { name: string; value: string | number }[] = [{ name: '测量类型配置', value: 1 }, { name: '因子组配置', value: 2 }];
    type = 1;
    leftData: { id: number; name: string }[] = [];
    rightData: { id: number; name: string }[] = [];
    checkData: number[] = [];
    currentMenu: Integer = null;
    service!: Strategy;
    loading: boolean = false;
    typeChnage(v) {
        this.type = v;
        this.service = this.type === 1 ? new MeasureTypeService(this) : new UnitConfigService(this);
        this.service.init();
    }
    mounted() {
        this.typeChnage(1);
    }
    leftMenuChange(id) {
        this.currentMenu = id;
        this.service.searchRelationById(id);
    }
    add() {
        this.service.add();
    }
    update(i) {
        this.service.update(i);
    }
    delete(i) {
        this.service.delete(i.id);
    }
    save() {
        this.service.updateRelation(this.currentMenu as number);
    }
    render(h) {
        return (
            <layout class={bem()}>
                <sider hide-trigger width={372} class={createNamespace('pa6')}>
                    <FrameSideBg style="height: 100%" padding={false}>
                        <SysSideList
                            value={this.currentMenu}
                            title={this.type === 1 ? '测量类型' : '因子组'}
                            dataSource={this.leftData}
                            on-add={this.add.bind(this)}
                            on-update={this.update.bind(this)}
                            on-delete={this.delete.bind(this)}
                            on-input={this.leftMenuChange.bind(this)}
                        />
                    </FrameSideBg>
                </sider>
                <i-content class={bem('content') + ' ' + createNamespace('pa6')}>
                    <div>
                        <Tab dataSource={this.tabs} value={this.type} on-input={this.typeChnage.bind(this)} style="display:inline-block"/>

                        <Button type="primary" on-click={this.save.bind(this)} style="float: right">
                            保存
                        </Button>
                    </div>
                    <FrameContentBg showCorner={false} radius={true} class={createNamespace('mt5')}>
                            <checkbox-group v-model={this.checkData}>
                                {this.rightData.map(i => {
                                    return (
                                        <checkbox size="large" label={i.id}>
                                            {i.name}
                                        </checkbox>
                                    );
                                })}
                            </checkbox-group>
                    </FrameContentBg>
                </i-content>
            </layout>
        );
    }
}
